<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>
    <el-table
      ref="noticeData"
      :data="noticeData"
      tooltip-effect="dark"
      v-loading="fetchLoding"
      style="width: 96%; margin: 20px auto; margin-bottom:60px;"
    >
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="created_at" :label="generateCustomizeString('createAt')">
        <template slot-scope="scope">{{scope.row.created_at | toLocalTime}}</template>
      </el-table-column>
      <el-table-column prop="updated_at" :label="generateCustomizeString('updatedAt')">
        <template slot-scope="scope">{{scope.row.updated_at | toLocalTime}}</template>
      </el-table-column>
      <el-table-column prop="content" :label="generateCustomizeString('noticeContent')"></el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button
            @click="editClick(scope.row)"
            type="text"
            size="small"
          >{{generateCustomizeString('edit')}}</el-button>
          <el-button
            @click="deleteClick(scope.row)"
            type="text"
            size="small"
          >{{generateCustomizeString('delete')}}</el-button>

          <el-dialog
            :title="generateCustomizeString('noticeConfirm')"
            :visible.sync="dialogVisible"
            width="30%"
            :append-to-body="true"
          >
            <span>{{generateCustomizeString('deleteNotice')}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
              <el-button
                type="primary"
                @click="deletePage()"
              >{{generateCustomizeString('deleteConfirm')}}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="generateCustomizeString('addNotice')"
      :visible.sync="addNoticeDialogVisible"
      width="50%"
      :append-to-body="true"
    >
      <el-form :model="addNoticeForm" label-width="80px" ref="ruleForm" style="padding: 0 20px;">
        <el-form-item :label="generateCustomizeString('noticeContent')">
          <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="addNoticeForm.content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addNoticeDialogVisible = false"
        >{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="addNoticeConfirm()"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('updateNotice')"
      :visible.sync="updateNoticeDialogVisible"
      width="50%"
      :append-to-body="true"
    >
      <el-form :model="updateNoticeForm" label-width="80px" ref="ruleForm" style="padding: 0 20px;">
        <el-form-item :label="generateCustomizeString('noticeContent')">
          <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="updateNoticeForm.content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addNoticeDialogVisible = false"
        >{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="updateNoticeConfirm()"
        >{{generateCustomizeString('update')}}</el-button>
      </span>
    </el-dialog>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="currentTotal"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'NoticeList',
  data() {
    return {
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL +
          this.$store.state.shop.shop_domain_prefix,
      noticeData: [],
      updateId: 0,
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0,
      addNoticeDialogVisible: false,
      updateNoticeDialogVisible: false,
      dialogVisible: false,
      fetchLoding: false,
      addNoticeForm: {
        content: ''
      },
      updateNoticeForm: {
        content: ''
      }
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchData(this.currentPage)
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    createClick() {
      this.addNoticeDialogVisible = true
    },
    editClick(row) {
      this.updateNoticeDialogVisible = true
      this.fetchNotice(row.id)
      this.updateId = row.id
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    addNoticeConfirm() {
      var data = {
        content: this.addNoticeForm.content
      }
      request({
        url: '/notice',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.fetchData(1)
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
        .finally(() => {
          this.addNoticeDialogVisible = false
          this.addNoticeForm.content = ''
        })
    },
    updateNoticeConfirm() {
      var data = {
        content: this.updateNoticeForm.content
      }
      request({
        url: 'notice/' + this.updateId,
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.fetchData(1)
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.updateNoticeDialogVisible = false
        })
    },
    fetchData(page) {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: '/notice/list',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta

          this.noticeData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    deletePage() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'notice/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    },
    fetchNotice(noticeId) {
      request({
        url: 'notice/' + noticeId,
        method: 'get'
      })
        .then(res => {
          this.updateNoticeForm = res.data
          console.log(this.updateNoticeForm)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created: function() {
    this.fetchData(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
